import { render, staticRenderFns } from "./deactiveFood.vue?vue&type=template&id=6492aebe&scoped=true&"
import script from "./deactiveFood.vue?vue&type=script&lang=js&"
export * from "./deactiveFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6492aebe",
  null
  
)

export default component.exports